import { Condition } from '../types/condition'

export const mockConditions: Condition[] = [
  // Pending (8)
  {
    id: '1',
    title: 'W-2 Forms 2023-2024',
    category: 'Income',
    status: 'Pending',
    dueDate: '2024-01-15',
    assignee: 'John',
    notes: 'Need both years for verification',
    priority: 'high',
    documents: [],
  },
  {
    id: '2',
    title: 'Paystubs - Last 30 Days',
    category: 'Income',
    status: 'Pending',
    dueDate: '2024-01-12',
    assignee: 'Sarah',
    notes: '',
    priority: 'high',
    documents: [
      {
        id: 'd1',
        name: 'Paystub_Dec_2024.pdf',
        type: 'application/pdf',
        size: 245000,
        uploadedAt: '2024-01-08T10:30:00Z',
        uploadedBy: 'Sarah',
        url: '#',
      },
    ],
  },
  {
    id: '3',
    title: 'Bank Statements - Checking',
    category: 'Assets',
    status: 'Pending',
    dueDate: '2024-01-18',
    assignee: 'John',
    notes: 'Last 2 months required',
    priority: 'medium',
    documents: [
      {
        id: 'd2',
        name: 'Bank_Statement_Nov_2024.pdf',
        type: 'application/pdf',
        size: 512000,
        uploadedAt: '2024-01-05T14:20:00Z',
        uploadedBy: 'John',
        url: '#',
      },
      {
        id: 'd3',
        name: 'Bank_Statement_Dec_2024.pdf',
        type: 'application/pdf',
        size: 498000,
        uploadedAt: '2024-01-05T14:22:00Z',
        uploadedBy: 'John',
        url: '#',
      },
    ],
  },
  {
    id: '4',
    title: 'Homeowners Insurance Quote',
    category: 'Insurance',
    status: 'Pending',
    dueDate: '2024-01-20',
    assignee: 'Lisa',
    notes: 'Must meet minimum coverage requirements',
    priority: 'medium',
    documents: [],
  },
  {
    id: '5',
    title: 'Property Survey',
    category: 'Property',
    status: 'Pending',
    dueDate: '2024-01-25',
    assignee: 'Mike',
    notes: '',
    priority: 'low',
    documents: [],
  },
  {
    id: '6',
    title: 'Tax Returns 2022-2023',
    category: 'Income',
    status: 'Pending',
    dueDate: '2024-01-14',
    assignee: 'Sarah',
    notes: 'Include all schedules',
    priority: 'high',
    documents: [],
  },
  {
    id: '7',
    title: 'Investment Account Statements',
    category: 'Assets',
    status: 'Pending',
    dueDate: '2024-01-22',
    assignee: 'John',
    notes: '401k and brokerage accounts',
    priority: 'medium',
    documents: [],
  },
  {
    id: '8',
    title: 'Flood Insurance Certificate',
    category: 'Insurance',
    status: 'Pending',
    dueDate: '2024-01-28',
    assignee: 'Lisa',
    notes: 'Property in flood zone',
    priority: 'medium',
    documents: [],
  },

  // In Progress (6)
  {
    id: '9',
    title: 'Employment Verification Letter',
    category: 'Income',
    status: 'In Progress',
    dueDate: '2024-01-16',
    assignee: 'Sarah',
    notes: 'HR department contacted',
    priority: 'high',
    documents: [],
  },
  {
    id: '10',
    title: 'Bank Statements - Savings',
    category: 'Assets',
    status: 'In Progress',
    dueDate: '2024-01-17',
    assignee: 'John',
    notes: 'Waiting for December statement',
    priority: 'medium',
    documents: [],
  },
  {
    id: '11',
    title: 'Termite Inspection Report',
    category: 'Property',
    status: 'In Progress',
    dueDate: '2024-01-19',
    assignee: 'Mike',
    notes: 'Inspector scheduled for Tuesday',
    priority: 'medium',
    documents: [],
  },
  {
    id: '12',
    title: 'Credit Explanation Letter',
    category: 'Credit',
    status: 'In Progress',
    dueDate: '2024-01-13',
    assignee: 'Sarah',
    notes: 'Explaining late payment from 2022',
    priority: 'high',
    documents: [],
  },
  {
    id: '13',
    title: 'Condo Association Questionnaire',
    category: 'Property',
    status: 'In Progress',
    dueDate: '2024-01-21',
    assignee: 'Lisa',
    notes: 'HOA management responding',
    priority: 'medium',
    documents: [],
  },
  {
    id: '14',
    title: 'Divorce Decree',
    category: 'Other',
    status: 'In Progress',
    dueDate: '2024-01-15',
    assignee: 'John',
    notes: 'Borrower locating documents',
    priority: 'high',
    documents: [],
  },

  // Submitted (5)
  {
    id: '15',
    title: 'Appraisal Report',
    category: 'Property',
    status: 'Submitted',
    dueDate: '2024-01-10',
    assignee: 'Mike',
    notes: 'Under review by underwriter',
    priority: 'high',
    documents: [
      {
        id: 'd4',
        name: 'Appraisal_Report_Final.pdf',
        type: 'application/pdf',
        size: 1240000,
        uploadedAt: '2024-01-09T16:45:00Z',
        uploadedBy: 'Mike',
        url: '#',
      },
    ],
  },
  {
    id: '16',
    title: 'Title Search',
    category: 'Property',
    status: 'Submitted',
    dueDate: '2024-01-11',
    assignee: 'Lisa',
    notes: 'Clear title confirmed',
    priority: 'high',
    documents: [],
  },
  {
    id: '17',
    title: 'Social Security Award Letter',
    category: 'Income',
    status: 'Submitted',
    dueDate: '2024-01-09',
    assignee: 'Sarah',
    notes: 'Verifying continuance',
    priority: 'medium',
    documents: [],
  },
  {
    id: '18',
    title: 'Retirement Account Statements',
    category: 'Assets',
    status: 'Submitted',
    dueDate: '2024-01-08',
    assignee: 'John',
    notes: '',
    priority: 'low',
    documents: [],
  },
  {
    id: '19',
    title: 'Debt Payoff Letter',
    category: 'Credit',
    status: 'Submitted',
    dueDate: '2024-01-12',
    assignee: 'Sarah',
    notes: 'Auto loan payoff confirmation',
    priority: 'medium',
    documents: [],
  },

  // Approved (4)
  {
    id: '20',
    title: 'Credit Report',
    category: 'Credit',
    status: 'Approved',
    dueDate: '2024-01-05',
    assignee: 'John',
    notes: 'Score meets requirements',
    priority: 'high',
    documents: [],
  },
  {
    id: '21',
    title: 'Purchase Agreement',
    category: 'Property',
    status: 'Approved',
    dueDate: '2024-01-03',
    assignee: 'Mike',
    notes: 'All addendums included',
    priority: 'high',
    documents: [],
  },
  {
    id: '22',
    title: 'Photo ID - Driver License',
    category: 'Other',
    status: 'Approved',
    dueDate: '2024-01-02',
    assignee: 'Lisa',
    notes: '',
    priority: 'low',
    documents: [],
  },
  {
    id: '23',
    title: 'Earnest Money Verification',
    category: 'Assets',
    status: 'Approved',
    dueDate: '2024-01-04',
    assignee: 'John',
    notes: 'Source of funds verified',
    priority: 'medium',
    documents: [],
  },

  // Waived (2)
  {
    id: '24',
    title: 'Gift Letter',
    category: 'Assets',
    status: 'Waived',
    dueDate: '2024-01-06',
    assignee: 'Sarah',
    notes: 'Not applicable - no gift funds',
    priority: 'low',
    documents: [],
  },
  {
    id: '25',
    title: 'HOA Documents',
    category: 'Property',
    status: 'Waived',
    dueDate: '2024-01-07',
    assignee: 'Lisa',
    notes: 'Single family home - no HOA',
    priority: 'low',
    documents: [],
  },
]
